import { ApiKeysActionTypes } from './constants';

const INIT_STATE = {
    apiKeys: [],
    loading: false,
    creating: false,
    deletingKeyId: null,
    error: null,
};

type ApiKeysAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string, apiKeyId?: string },
};

type State = {
    apiKeys: Array<any>,
    loading: Boolean,
    creating: Boolean,
    deletingKeyId: string | null,
    error: any,
};

const ApiKeys = (state: State = INIT_STATE, action: ApiKeysAction): any => {
    switch (action.type) {
        case ApiKeysActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case ApiKeysActionTypes.GET_ALL_API_KEYS:
                    return { ...state, loading: false, apiKeys: action.payload.data, error: null };
                case ApiKeysActionTypes.CREATE_API_KEY:
                    return {
                        ...state,
                        creating: false,
                        apiKeys: [action.payload.data, ...state.apiKeys],
                        error: null,
                    };
                case ApiKeysActionTypes.DELETE_API_KEY:
                    return {
                        ...state,
                        deletingKeyId: null,
                        apiKeys: state.apiKeys.filter((apiKey) => apiKey.id !== action.payload.data),
                        error: null,
                    };
                default:
                    return state;
            }
        case ApiKeysActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case ApiKeysActionTypes.GET_ALL_API_KEYS:
                    return { ...state, loading: false, error: action.payload.error };
                case ApiKeysActionTypes.CREATE_API_KEY:
                    return { ...state, creating: false, error: action.payload.error };
                case ApiKeysActionTypes.DELETE_API_KEY:
                    return { ...state, deletingKeyId: null, error: action.payload.error };
                default:
                    return state;
            }
        case ApiKeysActionTypes.GET_ALL_API_KEYS:
            return { ...state, loading: true };
        case ApiKeysActionTypes.CREATE_API_KEY:
            return { ...state, creating: true };
        case ApiKeysActionTypes.DELETE_API_KEY:
            return { ...state, deletingKeyId: action.payload.apiKeyId };
        case ApiKeysActionTypes.RESET_ALL_ERRORS:
            return { ...state, error: null };
        default:
            return state;
    }
};

export default ApiKeys;
